import styled from 'styled-components';
import RightIcon from '../../../assests/images/white-right-icon.svg';

export const ManageAccountSection = styled.div`
  .profile-form-section{
   @media screen and (max-width:991px) {
     padding-top:30px;
   }
  }
`;

export const ManageAccountTitle = styled.h1`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:40px;
    font-weight: bold;
    line-height: 58px;
    margin-bottom: 30px;

    @media screen and (max-width:1199px) {
      font-size: 35px;
      line-height: 40px;
    }
    @media screen and (max-width:991px) {
        font-size: 30px;
        line-height: 35px;
    }
    @media screen and (max-width:575px) {
        font-size: 28px;
        line-height: 40px;
        margin-bottom: 20px;
    }
`;

export const AccountBlue = styled.div`
    background: #01606F 0% 0% no-repeat padding-box;
    border-radius: 10px;
    padding:20px;

`;
export const AccountText = styled.p`
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight: 500;
    line-height: 27px;
    margin-bottom: 0px;
`;

export const AccountEdit = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 15px;
    padding:10px;
    margin-top:30px;

    .upload-img {
        height: 352px;
        width: 272px;
        position: relative;
        background-color: transparent;
        border: none;
        font-size: 0;
        @media screen and (max-width: 991px){
            height: 300px;
            width: 200px;
        }
    }

    .profile-upload { 
        display: flex;
        width: 100%;
        max-width: 272px;
        height: 100%;
        position: relative;
        margin-bottom: 0px;

        @media screen and (max-width: 991px){
            max-width: 200px;
            margin-bottom: 30px;
        }

        @media screen and (max-width:575px) {
          margin-bottom: 20px;
        }

        @media screen and (max-width: 400px){
            max-width: 100%;
        }

        img{
            width: 100%;
            height: 100%;
            display: block;
            object-fit: cover;
        }

        input#profile_picture {
            display: none;
        }
       
        &:after {
            content:"";
            position: absolute;
            // background:rgb(247 147 30 / 30%);
            width: 100%;
            height: 100%;
            margin: auto;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            border-radius: 8px;
            display: block;
        }
        
        .add-photo {
            position: absolute;
            z-index: 1;
            text-align: center;
            left: 0;
            right: 0;
            top: 50%;
            color: #fff;
            font-family: "Jost", sans-serif;
            font-size: 16px;
            font-weight: 400;
            line-height: 23px;
            transform: translateY(-50%);
        }
    }

    .form-label {
        color: #333333;
        font-family: "Jost", sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 23px;
        margin-bottom: 10px;
    }
    .form-control {
        background: #0000000D 0% 0% no-repeat padding-box;
        border: 1px solid #0000000D;
        border-radius: 10px;
        height: 50px;
    }
    .input-box {
        margin-bottom: 20px;
    }

    .input-box-two{
        @media screen and (max-width: 767px){
            margin-bottom: 20px;
        }
    }

    .form-check-input:focus {
        box-shadow:none;
    }
`;

export const ImageUpload = styled.div`
    max-width: 272px;
    max-height: 352px;
    position: relative;
    border-radius: 8px;

    @media screen and (max-width: 400px){
         max-width: 100%;
        max-height: 100%;
    }
    
    img{
        width: 100%;
        height: 100%;
        border-radius: 8px;
        object-fit: cover;
    }
`;

export const FileIcon = styled.span`
    background: rgb(51 51 51 / 40%) 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 8px;
    display: inline-flex;
    height: 60px;
    width: 60px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    
    img{
        width: 40px !important;
        height: 40px !important;
        display: block;
        object-fit: contain !important;
    }

    @media screen and (max-width: 991px){
        width: 40px;    
        height: 40px;
    }

    img{
        width: 100%;
        height: 100%;
        border-radius: 8px;
        object-fit: contain;
        max-width: 40px;

        @media screen and (max-width: 991px){
            max-width: 24px;
        }
    }
`;

export const CustomRadioBox = styled.div`
    display: flex;
    align-items: flex-start;
    margin-bottom:20px;
    
    .form-check-label {
        color: #333333;
        font-size: 16px;
        line-height: 27px;
        font-family: "Jost", sans-serif;
    }

    .form-check-input {
        width: 20px;
        height: 20px;
        margin-right: 10px;
    }

    .form-check-input {
        --bs-form-check-bg: transparent;
        border: 1px solid #33a7ae;
        border-radius: 4px;
    }

    .form-check-input:checked[type=radio]{
        --bs-form-check-bg-image:url(${RightIcon});
        background-size: 12px;
    }

    .form-check-input:checked {
        background-color:#33a7ae;
    }
`;

export const FromButton = styled.div`
    display: flex;
    justify-content: center;
    gap: 15px;

    &.manage-account-button{
        display: flex;
        justify-content: flex-start;
        
        @media screen and (max-width:480px) {
          flex-direction: column;
        }
    }
    
    .btn-outline-success-blue{
        padding: 12px 30px;
        
        @media screen and (max-width:575px) {
          padding: 12px 20px;
        }
    }
        
    .btn-outline{
        background: #fff;
        color: #01606F;
        font-family: "Jost", sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        padding: 10px 51px;
        transition: all 0.5s;
        border-radius: 10px;
        box-shadow: 0px 5px 20px #0000001A;
        border: 1px solid #01606F;
        border-radius: 10px;
        
        &:hover{
            background: #FFD495 !important;
            color: #333333 !important;
            transition: all 0.5s;
            border: 1px solid #FFD495;
        } 
        
        @media screen and (max-width:575px) {
          padding: 12px 40px;
        }
    }
`;